import React from 'react';
import { BtnPrimary } from '../Buttons/BtnPrimary';
import { BtnSecondary } from '../Buttons/BtnSecondary';
import styles from './Style.module.css';
import { Clock } from 'lucide-react';

/**
 * Shared layout for full-page status states (maintenance, 404, 500, ...).
 * Structure: a big status code (or an icon, for states with no HTTP code)
 * up top, heading, subtext, one primary action, and a small footer link.
 */
export const StatusPage = ({
  code,
  icon,
  heading,
  description,
  isBadge = false,
  badge,
  badgeTime,
  primaryLabel,
  onPrimaryClick,
  secondaryLabel,
  onSecondaryClick,
  footer,
}) => {

  return (
    <main className={`${styles.statusPage} container-md space-y space-x`} >
      <div className={styles.content}>
        {code ? (
          <p className={styles.code}>{code}</p>
        ) : (
          icon && <div className={styles.iconBadge}>{icon}</div>
        )}

        <h1 className={styles.heading}>{heading}</h1>
        <p className={styles.description}>{description}</p>

        {isBadge && 
        <div className={styles.badge}>
          <div className={styles.badgeIcon}>
          <Clock />
          </div>
          <div className={styles.badgeContent}>
            <div>{badgeTime ? 'Expected back online:' : "We'll be back online shortly"}</div>
            <div>{badgeTime && <time dateTime={badgeTime}>{badgeTime}</time>}</div>
          </div>
        </div>
        }

        <div className={styles.footer}>
          {primaryLabel && <BtnPrimary label={primaryLabel} handleClick={onPrimaryClick} customClass="no-icon w-100" />}
          {secondaryLabel && <BtnSecondary label={secondaryLabel} handleClick={onSecondaryClick} customClass="no-icon w-100" />}
        </div>
      </div>
        {footer && <p className={styles.footerText}>{footer}</p>}
    </main>
  );
};
